import { AppBar, Box, Button, Toolbar } from '@mui/material';
import AircLogo from '../assets/logo.svg';

interface NavbarProps {
  onLogout: () => void;
}

export const Navbar = ({ onLogout }: NavbarProps) => {
  return (
    <AppBar position="static" sx={{ bgcolor: 'white' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ height: '50px', display: 'flex', alignItems: 'center' }}>
          <img src={AircLogo} alt="AIRC Logo" style={{ height: '40px', width: 'auto' }} />
        </Box>
        <Button variant="outlined" color="primary" onClick={onLogout}>
          Esci
        </Button>
      </Toolbar>
    </AppBar>
  );
};
